import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useSearchParams } from 'react-router-dom';

import { CustomTable, Text } from '../../../shared/uiComponents';
import { Users } from '../../../shared/Assets/menuIcons';
import { MobileViewAdmin } from '../MobileView';
import { TableBodyAuthorization } from './tableInfo';
import { AUTHORIZATION_HEADERS, AuthorizationStatusInfo } from '../helpers';

import { DispatchProperties, useSelector } from '../../../redux/store';
import { getAuthorizationInfoAdmin } from '../../../redux/State/clientSlice/dashboardSlice';

const AuthorizationInfo = () => {
	const dispatch = useDispatch<DispatchProperties>();
	const [params] = useSearchParams();

	const loading = useSelector((state) => state.dashboard.loading);
	const authorization = useSelector((state) => state.dashboard.authorizations);

	useEffect(() => {
		const page = params.get('authPage') || '1';
		const pageSize = params.get('authPageSize') || '8';
		dispatch(
			getAuthorizationInfoAdmin({
				page,
				pageSize,
			}),
		);
	}, [params, dispatch]);

	return authorization.query?.length ? (
		<div className="dashboardCard">
			<div className="dashboardHeader">
				<div className="header">
					<div className="headerIcon">
						<Users />
					</div>
					<Text type="h6" font="header" fontWeight="semiBold" title="Authorizations" />
				</div>
				<AuthorizationStatusInfo showExpired />
			</div>
			<CustomTable
				headers={AUTHORIZATION_HEADERS}
				data={authorization}
				TableBody={TableBodyAuthorization}
				loading={loading}
				type="auth"
				siblingCount={0}
			/>
			<MobileViewAdmin data={authorization} />
		</div>
	) : null;
};

export default AuthorizationInfo;
